import { SxProps, Theme } from "@mui/material/styles";
import { colors } from "../../../ui/colors";

export const dashboardLayoutStyles = {
  root: {
    display: "flex",
    height: "90vh",
    py: 2,
    mt: 1,
    px: 4,
    border: "1px solid transparent",
    // borderRadius: "25px",
    background: "var(--fx-surface-base, #FFFFFF)",
    transition: "0.2s all ease-in",
    boxShadow: "0.2px 6px 10px 2px rgba(0, 0, 0, 0.10)",
    mr: 4,
    backgroundColor: "var(--fx-surface-base, #FFFFFF)",
  } as SxProps<Theme>,

  sidebar: {
    width: 240,
    backgroundColor: "var(--fx-surface-base, #FFFFFF)",
    borderRight: `1px solid ${colors.border || "var(--fx-surface-border, #E2E8F0)"}`,
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
  } as SxProps<Theme>,

  mainContent: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
  } as SxProps<Theme>,

  topBar: {
    backgroundColor: "var(--fx-surface-base, #FFFFFF)",
    borderBottom: `1px solid ${colors.border || "var(--fx-surface-border, #E2E8F0)"}`,
    boxShadow: "none",
    padding: "12px 24px",
  } as SxProps<Theme>,

  contentArea: {
    flex: 1,
    overflow: "auto",
    padding: "32px 24px",
  } as SxProps<Theme>,

  sidebarHeader: {
    padding: "16px",
    borderBottom: `1px solid ${colors.border || "var(--fx-surface-border, #E2E8F0)"}`,
    display: "flex",
    alignItems: "center",
    gap: 1,
  } as SxProps<Theme>,

  sidebarNav: {
    flex: 1,
    overflow: "auto",
    padding: "16px 8px",
  } as SxProps<Theme>,

  sidebarFooter: {
    padding: "16px",
    borderTop: `1px solid ${colors.border || "var(--fx-surface-border, #E2E8F0)"}`,
    backgroundColor: "var(--fx-surface-sunken, #F8FAFC)",
  } as SxProps<Theme>,

  navItem: {
    display: "flex",
    alignItems: "center",
    gap: 2,
    padding: "10px 12px",
    borderRadius: 1,
    cursor: "pointer",
    transition: "all 0.2s ease",
    color: "var(--fx-surface-textsecondary, #64748B)",
    textDecoration: "none",
    fontSize: "0.95rem",
    marginBottom: "4px",
    "&:hover": {
      backgroundColor: "var(--fx-surface-muted, #F1F5F9)",
      color: colors.accent || "#ff9500",
    },
    "&.active": {
      backgroundColor: "var(--fx-colors-warning-50, #FFF7ED)",
      color: colors.accent || "#ff9500",
      fontWeight: 500,
    },
  } as SxProps<Theme>,

  newSiteButton: {
    margin: "12px",
    backgroundColor: colors.accent || "#ff9500",
    color: "#ffffff",
    textTransform: "none",
    fontSize: "0.95rem",
    padding: "10px 16px",
    borderRadius: 1,
    "&:hover": {
      backgroundColor: colors.accentHover || "#e68900",
    },
  } as SxProps<Theme>,

  quickStartGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
    gap: 2,
    marginBottom: 4,
  } as SxProps<Theme>,

  projectGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fill, minmax(280px, 1fr))",
    gap: 2,
  } as SxProps<Theme>,

  projectList: {
    display: "flex",
    flexDirection: "column",
    gap: 1,
  } as SxProps<Theme>,
};
